<template>
  <Modal ref="modal" title="Deseja criar uma anotação para essa aula?" @cancel="close">
    <form class="export-container" @submit.prevent="handleSubmit">
      <div class="upload">
        <div class="input-container">
          <legend>Foto do instrutor</legend>
          <input type="file" ref="inputInstrutor" @change="handleFileUpload($event, 'instrutor')" :disabled="loading">
        </div>

        <div class="input-container">
          <legend>Foto do aluno</legend>
          <input type="file" ref="inputAluno" @change="handleFileUpload($event, 'aluno')" :disabled="loading">
        </div>

        <div class="input-container">
          <legend>Outras fotos</legend>
          <input type="file" ref="inputOutras" multiple @change="handleFileUpload($event, 'outras')"
            :disabled="loading">
        </div>
      </div>

      <Textarea legend="Motivo" placeholder="Escreva o motivo da criação aqui." :modelValue="motivo"
        @update:modelValue="$event => motivo = $event" :disabled="loading" />

      <Button type="submit" text="Criar" color="primary" :disabled="loading">
        <FolderPlusOutline :size="18" />
      </Button>
    </form>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import Textarea from 'core/Textarea'
import Button from 'core/Button'
import FolderPlusOutline from 'icons/FolderPlusOutline'

export default {
  name: 'CriarAnotacaoModal',
  components: {
    Modal,
    Textarea,
    Button,
    FolderPlusOutline,
  },
  props: {
    type: {
      type: String,
      default: 'full',
    },
  },
  data() {
    return {
      schema: '',
      motivo: 'Falha em funcionalidade',
      aula: null,
      files: {
        instrutor: null,
        aluno: null,
        outras: []
      },
      loading: false,
    }
  },
  methods: {
    open(aula, schema) {
      this.schema = schema
      this.aula = aula
      this.$refs.modal.open()
    },
    close() {
      this.schema = ''
      this.motivo = 'Falha em funcionalidade'
      this.files = {
        instrutor: null,
        aluno: null,
        outras: []
      }

      this.$nextTick(() => {
        if (this.$refs.inputInstrutor) this.$refs.inputInstrutor.value = ""
        if (this.$refs.inputAluno) this.$refs.inputAluno.value = ""
        if (this.$refs.inputOutras) this.$refs.inputOutras.value = ""
      })

      this.$refs.modal.close()
    },
    handleFileUpload(event, type) {
      if (type === 'outras') {
        this.files.outras = Array.from(event.target.files)
      } else {
        this.files[type] = event.target.files[0]
      }
    },
    async handleSubmit() {
      if (!this.validateInputs()) {
        return
      }

      this.loading = true

      const formData = new FormData()

      if (this.files.instrutor) {
        formData.append("foto_instrutor", this.files.instrutor)
      }

      if (this.files.aluno) {
        formData.append("foto_aluno", this.files.aluno)
      }

      this.files.outras.forEach((file, index) => {
        formData.append(`outras_fotos[${index}]`, file)
      })

      formData.append("schema", this.schema)
      formData.append("idAnotacao", this.aula.id)
      formData.append("observacao", this.motivo)

      await this.$http.post(`${process.env.VUE_APP_URL_API_V2}/aulas/praticas/criar/anotacao/id/${this.aula.id}`, formData)
        .then(res => {
          this.$toasted.show('Aula criada com sucesso!', {
            position: 'top-right',
            duration: 5000,
            fullWidth: false
          })
          this.close()
        })
        .catch(err => {
          this.toast(`Erro ao criar anotação: ${err.body.mensagem}`)
        })
        .finally(() => {
          this.loading = false

          this.$emit('submited')
        })
    },
    validateInputs() {
      if (!this.motivo || this.motivo.length < 8) {
        this.toast('O campo de "Motivo" é obrigatório e deve ter no mínimo 8 caracteres.')
        return false
      }

      return true
    },
    toast(text) {
      this.$toasted.show(text, {
        icon: 'fa-times',
        position: 'top-right',
        duration: 5000,
        fullWidth: false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.export-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .upload {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .input-container {
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      legend {
        margin: 0;
        font-size: 1rem;
        font-weight: 600;
        line-height: 21.82px;
        color: #606264;
      }
    }
  }

  .format-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    span {
      font-size: 1rem;
      font-weight: 600;
      line-height: 21.82px;
      color: #606264;
    }
  }

  button {
    justify-content: center;
  }
}
</style>